import _ from "lodash";

export const sourceOffsetSelector = (state, streamOverride = null) => {
    const playlist = state.playlist;

    let sourceOffset = _.get(playlist.data, ["offsets", playlist.position.sourceIndex], 0);
    if (streamOverride) {
        sourceOffset = _.get(playlist.data, ["offsets", streamOverride], 0);
    }

    const currentSession = state.sessions[state.playlist.data.routeID];
    const sessionTags = _.get(currentSession, ["tags"], []);
    const sessionIsBackward = _.indexOf(sessionTags, "Backward") !== -1;

    if (sessionIsBackward) {
        sourceOffset *= -1;
    }

    return sourceOffset;
};

export const routeGeomSelector = (state) => state.playlist.data.route_locations_v2;

export const currentDashboardSelector = (state) => _.find(state.dashboards, (dashboard) => dashboard.access_token === state.access_token);

export const weatherDataSelector = (state) => state.weatherCache.data;
export const weatherCoordsSelector = (state) => state.weatherCache.coords;
export const weatherRequestedTimestampSelector = (state) => state.weatherCache.requestedTimestamp;
